import React, { useState } from "react";
import Button from "../../components/ui/Button";
import { useAuth } from "../../context/AuthContext";
import { loadRequestApi } from "../../api/loadrequest";
import Swal from 'sweetalert2';

export default function LoadRequestCard({
  id,
  amount,
  status,
  referenceNo,
  note,
  requestFrom,
  requestTo,
  mobileNo,
  date,
  onStatusUpdate,
  approvedNotes,
  userId,
  user,
  proofOfPaymentUrl
}) {
  const { tokens } = useAuth();
  const [isUpdating, setIsUpdating] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  console.log(user.id, userId);
  const handleStatusUpdate = async (newStatus) => {
    try {
      const { value: notes } = await Swal.fire({
        title: `Enter notes for ${newStatus.toLowerCase()}`,
        input: 'text',
        inputLabel: 'Notes',
        inputPlaceholder: 'Enter your notes here...',
        inputValidator: (value) => {
          if (!value) return 'Notes cannot be empty!'
        },
        customClass: {
          popup: 'font-poppins',
          title: 'text-lg font-semibold',
          input: 'rounded-lg p-2.5',
          confirmButton: 'bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg',
          actions: 'gap-3'
        }
      });

      if (notes) {
        setIsUpdating(true);
        const { status } = await loadRequestApi.updateLoadRequest(
          tokens.access.token,
          id,
          newStatus,
          notes
        );
        if (status === 200) onStatusUpdate?.();
      }
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <>
      <div className="p-4 bg-white border border-[#E1E7EF] rounded-lg ">
        <div className="flex justify-between items-start mb-4">
          <span className="text-2xl font-bold text-[#0E64D1]">₱{amount}</span>
          <span
            className={`px-3 py-1 rounded-full text-sm ${
              status === "pending"
                ? "bg-[#FFE771] text-[#733F12]"
                : status === "approved"
                ? "bg-[#85EFAC] text-[#114C29]"
                : "bg-red-300 text-red-900"
            }`}
          >
            Request {status}
          </span>
        </div>

        <div className="space-y-3">
          <div>
            <div className="text-xs font-normal text-[#65758B]">Reference No.</div>
            <div className="text-sm font-medium">{referenceNo}</div>
          </div>

          <div>
            <div className="text-xs font-normal text-[#65758B]">Note</div>
            <div className="text-sm font-medium">{note}</div>
          </div>

          <div>
            <div className="text-xs font-normal text-[#65758B]">Request From</div>
            <div className="text-sm font-medium">{requestFrom}</div>
          </div>

          <div>
            <div className="text-xs font-normal text-[#65758B]">Request To</div>
            <div className="text-sm font-medium">{requestTo}</div>
          </div>

          <div>
            <div className="text-xs font-normal text-[#65758B]">
              Mobile No./Bank Account No.
            </div>
            <div className="text-sm font-medium">{mobileNo}</div>
          </div>

          <div>
            <div className="text-xs font-normal text-[#65758B]">Date</div>
            <div className="text-sm font-medium">{date}</div>
          </div>

          {status === "approved" && (
            <div>
              <div className="text-xs font-normal text-[#65758B]">Approved Notes</div>
              <div className="text-sm font-medium">{approvedNotes}</div>
            </div>
          )}

          {status === "pending" && (
            userId !== user.id && (
            <div className="text-center space-x-2.5 w-full pt-2 text-white text-sm">
              <Button
                className="bg-[#1AC057] hover:bg-green-600 px-5 py-2.5 rounded-lg"
                text={isUpdating ? "Processing..." : "Approve"}
                disabled={isUpdating}
                onClick={() => handleStatusUpdate("APPROVED")}
              />
              <Button
                variant="destructive"
                className="bg-[#EF4343] hover:bg-red-600 px-5 py-2.5 rounded-lg"
                text={isUpdating ? "Processing..." : "Decline"}
                disabled={isUpdating}
                onClick={() => handleStatusUpdate("REJECTED")}
              />
            </div>
            )
          )}
        </div>
        {proofOfPaymentUrl && (
          <div className="mt-4">
            <div className="text-xs font-normal text-[#65758B]">Proof of Payment</div>
            <img 
              src={proofOfPaymentUrl} 
              alt="Proof of Payment" 
              className="w-20 h-20 object-cover rounded-lg cursor-pointer border-2 border-gray-200 hover:border-blue-400 transition-colors"
              onClick={() => setShowImageModal(true)}
            />
          </div>
        )}

        {showImageModal && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
            onClick={() => setShowImageModal(false)}
          >
            <div className="relative max-w-4xl max-h-[90vh] p-4">
              <button
                onClick={() => setShowImageModal(false)}
                className="absolute top-2 right-2 text-white bg-black bg-opacity-50 rounded-full w-8 h-8 flex items-center justify-center hover:bg-opacity-75 transition-colors z-10"
              >
                ×
              </button>
              <img 
                src={proofOfPaymentUrl} 
                alt="Proof of Payment - Full Size" 
                className="max-w-full max-h-full object-contain rounded-lg"
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
